import type { ApplicationValidation } from "../api/client";
import { StepRail } from "../components/StepRail";
import { stepComplete, STEPS } from "./application";

/**
 * The certification body's six segments, over the shared rail.
 *
 * The Platform segment covers two of the server's answers, brand and configuration,
 * because screen 06 is one step with two cards; it is done when both are — which is why
 * completeness is answered here rather than by the rail.
 */
export function Stepper({
  current,
  furthest,
  validation,
  onSelect,
}: {
  current: number;
  furthest: number;
  validation: ApplicationValidation | null;
  onSelect: (index: number) => void;
}) {
  return (
    <StepRail
      titles={STEPS.map((step) => step.title)}
      current={current}
      furthest={furthest}
      isComplete={(index) => stepComplete(validation, STEPS[index])}
      onSelect={onSelect}
    />
  );
}
